import {post, put, retire} from "$lib/api";

export const addWorkEntry = async (project:any, workEntry:any) => {
    return await post(`/project/${project.uuid}/work-entry`, workEntry);
}
export const deleteWorkEntry = async (project:any, workEntry:any) => {

    return await retire(`/project/${project.uuid}/work-entry/${workEntry.uuid}`);
}

export const updateWorkEntry = async (project:any, workEntry:any) => {

    return await put(`/project/${project.uuid}/work-entry/${workEntry.uuid}`, workEntry);
}